export const EMAIL_ACTIONS = {
  DRAFT: "draft",
  SEND: "send",
  STOP: "stop",
  DELETE: "delete",
};

export const EMAIL_MESSAGE_STATUSES = {
  DRAFT: 1700,
  SENT: 1710,
  PENDING: 1720,
  PROCESSING: 1730,
  DELETED: 1740,
  PARTIALLY_SENT: 1750,
  FAILED: 1760,
  STOPPED: 1770,
};

export const EMAIL_RECIPIENT_STATUSES = {
  SENT: 1800,
  PENDING: 1810,
  PROCESSING: 1820,
  FAILED: 1830,
  DRAFT: 1840,
  STOPPED: 1850,
};

export const MAIL_TOOL_STOP_WARNING_COLOR = "#b45309";
export const MAIL_TOOL_STOP_WARNING_DARK_COLOR = "#92400e";

export const MAIL_TOOL_STOP_WARNING_BUTTON_SX = {
  backgroundColor: MAIL_TOOL_STOP_WARNING_COLOR,
  color: "#fff",
  "&:hover": {
    backgroundColor: MAIL_TOOL_STOP_WARNING_DARK_COLOR,
  },
};

export const MAIL_TOOL_STOP_WARNING_CHIP_SX = {
  backgroundColor: MAIL_TOOL_STOP_WARNING_COLOR,
  color: "#fff",
};

export const DEFAULT_RECIPIENT_FILTERS = {
  seasonIds: [],
  applicationTypeIds: [],
  applicationStatusIds: [],
  genderId: "",
  emailConfirmed: "",
  search: "",
};

export const EMAIL_CONFIRMED_OPTIONS = [
  { value: "true", label: "Επιβεβαιωμένο" },
  { value: "false", label: "Μη επιβεβαιωμένο" },
];

export const MESSAGE_STATUS_META = {
  [EMAIL_MESSAGE_STATUSES.DRAFT]: { label: "Πρόχειρο", color: "default" },
  [EMAIL_MESSAGE_STATUSES.SENT]: { label: "Απεστάλη", color: "success" },
  [EMAIL_MESSAGE_STATUSES.PENDING]: { label: "Σε αναμονή", color: "warning" },
  [EMAIL_MESSAGE_STATUSES.PROCESSING]: {
    label: "Σε επεξεργασία",
    color: "info",
  },
  [EMAIL_MESSAGE_STATUSES.DELETED]: { label: "Διαγραμμένο", color: "default" },
  [EMAIL_MESSAGE_STATUSES.PARTIALLY_SENT]: {
    label: "Μερικώς απεστάλη",
    color: "warning",
  },
  [EMAIL_MESSAGE_STATUSES.FAILED]: { label: "Απέτυχε", color: "error" },
  [EMAIL_MESSAGE_STATUSES.STOPPED]: {
    label: "Σταματημένο",
    color: "warning",
    sx: MAIL_TOOL_STOP_WARNING_CHIP_SX,
  },
};

export const RECIPIENT_STATUS_META = {
  [EMAIL_RECIPIENT_STATUSES.SENT]: { label: "Απεστάλη", color: "success" },
  [EMAIL_RECIPIENT_STATUSES.PENDING]: { label: "Σε αναμονή", color: "warning" },
  [EMAIL_RECIPIENT_STATUSES.PROCESSING]: {
    label: "Σε επεξεργασία",
    color: "info",
  },
  [EMAIL_RECIPIENT_STATUSES.FAILED]: { label: "Απέτυχε", color: "error" },
  [EMAIL_RECIPIENT_STATUSES.DRAFT]: { label: "Πρόχειρο", color: "default" },
  [EMAIL_RECIPIENT_STATUSES.STOPPED]: {
    label: "Σταματημένο",
    color: "warning",
    sx: MAIL_TOOL_STOP_WARNING_CHIP_SX,
  },
};

export const EDITABLE_MESSAGE_STATUSES = [
  EMAIL_MESSAGE_STATUSES.DRAFT,
  EMAIL_MESSAGE_STATUSES.STOPPED,
  EMAIL_MESSAGE_STATUSES.FAILED,
];

export const SENDABLE_MESSAGE_STATUSES = [
  EMAIL_MESSAGE_STATUSES.DRAFT,
  EMAIL_MESSAGE_STATUSES.STOPPED,
  EMAIL_MESSAGE_STATUSES.FAILED,
];

export const STOPPABLE_MESSAGE_STATUSES = [
  EMAIL_MESSAGE_STATUSES.PENDING,
  EMAIL_MESSAGE_STATUSES.PROCESSING,
  EMAIL_MESSAGE_STATUSES.PARTIALLY_SENT,
];

export const DELIVERY_LOG_MESSAGE_STATUSES = [
  EMAIL_MESSAGE_STATUSES.SENT,
  EMAIL_MESSAGE_STATUSES.PENDING,
  EMAIL_MESSAGE_STATUSES.PROCESSING,
  EMAIL_MESSAGE_STATUSES.PARTIALLY_SENT,
  EMAIL_MESSAGE_STATUSES.FAILED,
  EMAIL_MESSAGE_STATUSES.STOPPED,
];

export const DELIVERY_LOG_POLLING_MESSAGE_STATUSES = [
  EMAIL_MESSAGE_STATUSES.PENDING,
  EMAIL_MESSAGE_STATUSES.PROCESSING,
];
